import axios from 'axios'
import { CompanyDataFromGus } from '@models/invoice'
import { getState } from '@store/index'

export async function getCompanyData(nip: string): Promise<CompanyDataFromGus> {
  const url = getState().appDataState.appData.urls.sale.nip_search
  const { data } = await axios.get(url, { params: { nip } })
  return data
}
